import { render } from "./ConfigParametersIndex.vue?vue&type=template&id=01f8f904"
import script from "./ConfigParametersIndex.vue?vue&type=script&lang=js"
export * from "./ConfigParametersIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__